/**
 * @generated SignedSource<<37f70793a7d265ebee8c15b901e54941>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest } from 'relay-runtime';
export type CreatePostMutation$variables = {
  categoryId: string;
  content: string;
  tags?: ReadonlyArray<string> | null | undefined;
  title: string;
  type: string;
};
export type CreatePostMutation$data = {
  readonly unified: {
    readonly ai: {
      readonly createPost: {
        readonly errors: ReadonlyArray<{
          readonly code: string | null | undefined;
          readonly message: string;
        } | null | undefined> | null | undefined;
        readonly post: {
          readonly author: {
            readonly aaid: string;
            readonly id: string;
            readonly nickname: string | null | undefined;
          } | null | undefined;
          readonly author_id: string;
          readonly category: {
            readonly description: string | null | undefined;
            readonly id: string;
            readonly name: string;
          } | null | undefined;
          readonly category_id: string;
          readonly content: string;
          readonly created_at: string;
          readonly id: string;
          readonly tags: ReadonlyArray<string>;
          readonly title: string;
          readonly type: string;
          readonly updated_at: string;
        } | null | undefined;
        readonly success: boolean;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type CreatePostMutation = {
  response: CreatePostMutation$data;
  variables: CreatePostMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "categoryId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "content"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tags"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "title"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "type"
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "UnifiedMutation",
    "kind": "LinkedField",
    "name": "unified",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UnifiedAiMutation",
        "kind": "LinkedField",
        "name": "ai",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "categoryId",
                "variableName": "categoryId"
              },
              {
                "kind": "Variable",
                "name": "content",
                "variableName": "content"
              },
              {
                "kind": "Variable",
                "name": "tags",
                "variableName": "tags"
              },
              {
                "kind": "Variable",
                "name": "title",
                "variableName": "title"
              },
              {
                "kind": "Variable",
                "name": "type",
                "variableName": "type"
              }
            ],
            "concreteType": "UnifiedAiPostPayload",
            "kind": "LinkedField",
            "name": "createPost",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "success",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UnifiedAiPost",
                "kind": "LinkedField",
                "name": "post",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "content",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "type",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "category_id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "author_id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "created_at",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updated_at",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "tags",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnifiedAiAccount",
                    "kind": "LinkedField",
                    "name": "author",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "aaid",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "nickname",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnifiedAiCategory",
                    "kind": "LinkedField",
                    "name": "category",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "description",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UnifiedAiError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "message",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CreatePostMutation",
    "selections": (v6/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "CreatePostMutation",
    "selections": (v6/*: any*/)
  },
  "params": {
    "cacheID": "41465e4be3ce59164cf5e38785f5628d",
    "id": null,
    "metadata": {},
    "name": "CreatePostMutation",
    "operationKind": "mutation",
    "text": "mutation CreatePostMutation(\n  $title: String!\n  $content: String!\n  $type: String!\n  $categoryId: String!\n  $tags: [String!]\n) {\n  unified {\n    ai {\n      createPost(title: $title, content: $content, type: $type, categoryId: $categoryId, tags: $tags) {\n        success\n        post {\n          id\n          title\n          content\n          type\n          category_id\n          author_id\n          created_at\n          updated_at\n          tags\n          author {\n            id\n            aaid\n            nickname\n          }\n          category {\n            id\n            name\n            description\n          }\n        }\n        errors {\n          message\n          code\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e1380a082785fcfd05a85a569e64ca09";

export default node;
